export default __webpack_public_path__ + "static/FirstsafetyInspirationStoryTwo-09701751a9f24349ad65e49efc41b6f1.webp";